import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import useIsMobile from "../../../hooks/useIsMobile";
import ProblemEditorDialog from "./dialogs/ProblemEditorDialog";
import ProblemPreviewImageDialog from "./dialogs/ProblemPreviewImageDialog";
import ProblemFilter from "./filter/ProblemFilter";
import ProblemStatusTabs from "./table/ProblemStatusTabs";
import ProblemTableCard from "./table/ProblemTableCard";
import useProblemEditor from "../hooks/useProblemEditor";
import useProblemList from "../hooks/useProblemList";
import useProblemPermission from "../hooks/useProblemPermission";
import { problemStatusTabs } from "../utils/problemConstants";

// Problem page shared by problem kendaraan and problem kendaraan trado.
// variant = { config } from problem-kendaraan/utils or problem-kendaraan-trado/utils
const ProblemMain = ({ variant }) => {
  const { config } = variant;
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const { permittedToEdit } = useProblemPermission();
  const list = useProblemList({ config });
  const editor = useProblemEditor({ config, list });

  // useEffect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title: config.title }));
    list.handleOnInitialLoad();
  }, []);

  const activeTab = problemStatusTabs.find((el) => el.status === list.status);

  const handlers = {
    permittedToEdit,
    onEdit: editor.handleOnEdit,
    onDelete: editor.handleOnDelete,
    onClickImage: editor.handleOnClickImage,
    onClickShowPengecekan: editor.handleOnClickShowPengecekan,
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ConfirmDialog />
      <ProblemPreviewImageDialog
        data={editor.editorData}
        visible={editor.showImagePreview}
        onHide={(e) => editor.setShowImagePreview(false)}
      />
      <ProblemEditorDialog
        data={editor.editorData}
        setData={editor.setEditorData}
        addNewMode={editor.addNewMode}
        loading={editor.editorLoading}
        error={editor.editorError}
        setError={editor.setEditorError}
        visible={editor.editorDialogShowed}
        onHide={() => editor.setEditorDialogShowed(false)}
        onConfirm={editor.handleConfirmEditor}
      />
      <ProblemStatusTabs
        status={list.status}
        statusCounts={list.statusCounts}
        onChangeStatus={list.handleOnChangeStatus}
      >
        <ProblemFilter
          filterValue={list.filterValue}
          setFilterValue={list.setFilterValue}
          onClickRefresh={list.handleOnClickRefresh}
        />

        {/* TABEL PROBLEM (satu list per status) */}
        <ProblemTableCard
          title={activeTab.title}
          value={list.listData}
          selection={list.selectedData}
          setSelection={list.setSelectedData}
          loading={list.loading}
          paging={list.paging}
          onPage={list.handleOnPage}
          isMobile={isMobile}
          sortable={config.sortable.old}
          formatLabelGrup={config.formatLabelGrup}
          handlers={handlers}
        />
      </ProblemStatusTabs>
    </div>
  );
};

export default ProblemMain;
